import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import { useIntl } from "gatsby-plugin-intl";
import config from "../../config";

export const RecaptchaProvider = ({ children }) => {
  const { locale } = useIntl();
  return (
    <>
      <Helmet>
        <script
          async
          defer
          src={`https://www.google.com/recaptcha/api.js?hl=${locale}`}
        />
      </Helmet>

      {children}
    </>
  );
};

const Recaptcha = ({ className, ...props }) => {
  return (
    <div
      className={classNames("g-recaptcha", className)}
      data-sitekey={config.RECAPTCHA_SITE_KEY}
      {...props}
    />
  );
};

Recaptcha.propTypes = {
  className: PropTypes.string,
};

export default Recaptcha;
